module.exports = __webpack_public_path__ + "img/cattunnel30.d77d9a92.jpg";